import { useState, useEffect } from 'react'
import { FiPlus, FiEdit2, FiTrash2, FiX, FiCheck, FiCalendar } from 'react-icons/fi'
import * as FiIcons from 'react-icons/fi'
import toast from 'react-hot-toast'
import { API_URL } from '../config/api'
import { useEmpresaGestion } from '../contexts/EmpresaGestionContext'
import { PageHeader, Btn } from '../ui'

const ICONOS = [
  { value: 'FiSun', label: 'Sol' },
  { value: 'FiHeart', label: 'Corazón' },
  { value: 'FiCoffee', label: 'Café' },
  { value: 'FiBriefcase', label: 'Maletín' },
  { value: 'FiCalendar', label: 'Calendario' },
  { value: 'FiClock', label: 'Reloj' },
  { value: 'FiUser', label: 'Persona' },
  { value: 'FiHome', label: 'Casa' },
  { value: 'FiMoreHorizontal', label: 'Otro' },
  { value: 'FiThermometer', label: 'Termómetro' },
  { value: 'FiActivity', label: 'Actividad' },
  { value: 'FiAlertCircle', label: 'Alerta' },
  { value: 'FiAward', label: 'Premio' },
  { value: 'FiBookOpen', label: 'Libro' },
  { value: 'FiFeather', label: 'Pluma' },
  { value: 'FiGift', label: 'Regalo' },
  { value: 'FiMapPin', label: 'Ubicación' },
  { value: 'FiShield', label: 'Escudo' },
  { value: 'FiStar', label: 'Estrella' },
  { value: 'FiTruck', label: 'Transporte' },
  { value: 'FiUmbrella', label: 'Paraguas' },
  { value: 'FiZap', label: 'Rayo' },
  { value: 'FiSmile', label: 'Sonrisa' },
  { value: 'FiPaperclip', label: 'Clip' },
  { value: 'FiPhone', label: 'Teléfono' },
  { value: 'FiTool', label: 'Herramienta' },
  { value: 'FiFileText', label: 'Documento' },
  { value: 'FiUsers', label: 'Grupo' },
]

const COLORES = [
  { value: 'bg-amber-100 text-amber-700', label: 'Ámbar', dot: 'bg-amber-500' },
  { value: 'bg-red-100 text-red-700', label: 'Rojo', dot: 'bg-red-500' },
  { value: 'bg-blue-100 text-blue-700', label: 'Azul', dot: 'bg-blue-500' },
  { value: 'bg-green-100 text-green-700', label: 'Verde', dot: 'bg-green-500' },
  { value: 'bg-purple-100 text-purple-700', label: 'Morado', dot: 'bg-purple-500' },
  { value: 'bg-orange-100 text-orange-700', label: 'Naranja', dot: 'bg-orange-500' },
  { value: 'bg-teal-100 text-teal-700', label: 'Turquesa', dot: 'bg-teal-500' },
  { value: 'bg-pink-100 text-pink-700', label: 'Rosa', dot: 'bg-pink-500' },
  { value: 'bg-[var(--bg-2)] text-[var(--ink-2)]', label: 'Gris', dot: 'bg-gray-500' },
]

// Generar codigo automáticamente desde el nombre
const generarCodigo = (nombre) => {
  return nombre
    .toLowerCase()
    .normalize('NFD').replace(/[\u0300-\u036f]/g, '') // quitar acentos
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '')
}

export default function GestionTiposAusencia() {
  const { empresaId: empresaGestionId, esGestion } = useEmpresaGestion()
  const [tipos, setTipos] = useState([])
  const [loading, setLoading] = useState(false)
  const [modal, setModal] = useState({ open: false, tipo: null })
  const [form, setForm] = useState({
    codigo: '', nombre: '', icono: 'FiCalendar', color: 'bg-[var(--bg-2)] text-[var(--ink-2)]',
    requiere_documento: false, solo_admin: false, orden: 0
  })

  const buildUrl = (path) => {
    const sep = path.includes('?') ? '&' : '?'
    return esGestion && empresaGestionId ? `${API_URL}${path}${sep}empresa_id=${empresaGestionId}` : `${API_URL}${path}`
  }
  const token = () => localStorage.getItem('token')
  const hdrs = () => ({ 'Authorization': `Bearer ${token()}`, 'Content-Type': 'application/json' })

  useEffect(() => { cargar() }, [empresaGestionId])

  const cargar = async () => {
    setLoading(true)
    try {
      const r = await fetch(buildUrl('/tipos-ausencia'), { headers: hdrs() })
      if (r.ok) setTipos(await r.json())
    } catch { toast.error('Error al cargar tipos de ausencia') }
    finally { setLoading(false) }
  }

  const abrirModal = (tipo = null) => {
    if (tipo) {
      setForm({
        codigo: tipo.codigo, nombre: tipo.nombre, icono: tipo.icono, color: tipo.color,
        requiere_documento: tipo.requiere_documento === 1, solo_admin: tipo.solo_admin === 1, orden: tipo.orden
      })
    } else {
      setForm({ codigo: '', nombre: '', icono: 'FiCalendar', color: 'bg-[var(--bg-2)] text-[var(--ink-2)]', requiere_documento: false, solo_admin: false, orden: tipos.length })
    }
    setModal({ open: true, tipo })
  }

  const cerrarModal = () => { setModal({ open: false, tipo: null }) }

  const handleNombreChange = (nombre) => {
    const newForm = { ...form, nombre }
    // Auto-generar código solo al crear
    if (!modal.tipo) {
      newForm.codigo = generarCodigo(nombre)
    }
    setForm(newForm)
  }

  const guardar = async (e) => {
    e.preventDefault()
    if (!form.nombre) { toast.error('El nombre es obligatorio'); return }
    // Asegurar que hay código
    const dataToSend = { ...form }
    if (!dataToSend.codigo) {
      dataToSend.codigo = generarCodigo(form.nombre)
    }
    try {
      const url = modal.tipo ? buildUrl(`/tipos-ausencia/${modal.tipo.id}`) : buildUrl('/tipos-ausencia')
      const r = await fetch(url, { method: modal.tipo ? 'PUT' : 'POST', headers: hdrs(), body: JSON.stringify(dataToSend) })
      if (r.ok) {
        toast.success(modal.tipo ? 'Tipo actualizado' : 'Tipo creado')
        cerrarModal()
        cargar()
      } else { const err = await r.json(); toast.error(err.error || 'Error al guardar') }
    } catch { toast.error('Error de conexión') }
  }

  const eliminar = async (id) => {
    if (!window.confirm('¿Eliminar este tipo de ausencia?')) return
    try {
      const r = await fetch(buildUrl(`/tipos-ausencia/${id}`), { method: 'DELETE', headers: hdrs() })
      if (r.ok) { toast.success('Tipo eliminado'); cargar() }
      else { const err = await r.json(); toast.error(err.error || 'Error') }
    } catch { toast.error('Error de conexión') }
  }

  return (
    <div className="space-y-6">
      <PageHeader
        num="§ TA"
        kicker="Tipos de ausencia"
        title="Tipos de"
        italic="ausencia."
        sub="Configura los tipos de ausencia disponibles para los empleados."
        actions={<Btn variant="primary" size="sm" onClick={() => abrirModal()}><FiPlus size={14} /> Nuevo tipo</Btn>}
        className="!px-0 !pt-0 !pb-5 !border-0"
      />

      {!loading && tipos.length === 0 && (
        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <p className="text-sm text-blue-800">
            No tienes tipos de ausencia configurados. Crea al menos los tipos básicos: <strong>Vacaciones</strong>, <strong>Baja Médica</strong>, <strong>Permiso Retribuido</strong>, etc.
          </p>
        </div>
      )}

      <div className="card p-4">
        {loading ? (
          <div className="text-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600 mx-auto"></div>
          </div>
        ) : tipos.length === 0 ? (
          <div className="text-center py-8 text-[var(--ink-3)]">
            <FiCalendar className="h-12 w-12 mx-auto mb-3 text-[var(--ink-4)]" />
            <p className="font-medium">No hay tipos de ausencia</p>
            <p className="text-sm mt-1">Crea el primer tipo haciendo clic en "Nuevo tipo"</p>
          </div>
        ) : (
          <div className="space-y-2">
            {tipos.map(tipo => {
              const IconComponent = FiIcons[tipo.icono] || FiCalendar
              return (
                <div key={tipo.id} className="flex items-center justify-between p-3 rounded-lg border border-[var(--line)] hover:border-blue-300 hover:bg-blue-50/50 transition-all">
                  <div className="flex items-center gap-3 flex-1 min-w-0">
                    <span className={`inline-flex items-center justify-center w-9 h-9 rounded-lg shrink-0 ${tipo.color}`}>
                      <IconComponent className="h-5 w-5" />
                    </span>
                    <div className="min-w-0">
                      <span className="font-medium text-[var(--ink)] block truncate">{tipo.nombre}</span>
                      <div className="flex flex-wrap gap-1.5 mt-0.5">
                        {tipo.solo_admin === 1 && (
                          <span className="text-[10px] bg-purple-100 text-purple-700 px-1.5 py-0.5 rounded-full font-medium">Solo admin</span>
                        )}
                        {tipo.requiere_documento === 1 && (
                          <span className="text-[10px] bg-orange-100 text-orange-700 px-1.5 py-0.5 rounded-full font-medium">Requiere justificante</span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-1 shrink-0">
                    <button onClick={() => abrirModal(tipo)} className="p-2 text-blue-600 hover:bg-blue-100 rounded-lg" title="Editar">
                      <FiEdit2 className="h-4 w-4" />
                    </button>
                    <button onClick={() => eliminar(tipo.id)} className="p-2 text-red-600 hover:bg-red-100 rounded-lg" title="Eliminar">
                      <FiTrash2 className="h-4 w-4" />
                    </button>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>

      {/* Modal */}
      {modal.open && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" onClick={cerrarModal}>
          <div className="bg-white rounded-xl shadow-xl w-full max-w-md max-h-[90vh] overflow-y-auto" onClick={e => e.stopPropagation()}>
            <div className="flex items-center justify-between p-5 border-b">
              <h3 className="text-lg font-semibold">{modal.tipo ? 'Editar tipo' : 'Nuevo tipo de ausencia'}</h3>
              <button onClick={cerrarModal} className="text-[var(--ink-4)] hover:text-[var(--ink-2)]"><FiX size={20} /></button>
            </div>
            <form onSubmit={guardar} className="p-5 space-y-4">
              {/* Nombre */}
              <div>
                <label className="label">Nombre *</label>
                <input type="text" value={form.nombre} onChange={e => handleNombreChange(e.target.value)}
                  className="px-3 py-2 bg-[var(--bg-2)] border border-[var(--line)] rounded-soft text-[14px] w-full" placeholder="Ej: Vacaciones, Baja Médica" required autoFocus />
              </div>

              {/* Icono y color — selector visual */}
              <div>
                <label className="label">Icono y color</label>
                <div className="border border-[var(--line)] rounded-lg p-3 space-y-3">
                  {/* Selector de iconos — grid visual */}
                  <div className="grid grid-cols-7 gap-1.5">
                    {ICONOS.map(i => {
                      const Icon = FiIcons[i.value] || FiCalendar
                      const selected = form.icono === i.value
                      return (
                        <button key={i.value} type="button" onClick={() => setForm({ ...form, icono: i.value })} title={i.label}
                          className={`flex items-center justify-center w-9 h-9 rounded-lg transition-all ${
                            selected ? 'bg-blue-100 text-blue-700 ring-2 ring-blue-400' : 'bg-[var(--bg-2)] text-[var(--ink-3)] hover:bg-[var(--bg-2)]'
                          }`}>
                          <Icon className="h-4.5 w-4.5" />
                        </button>
                      )
                    })}
                  </div>
                  {/* Selector de colores — dots */}
                  <div className="flex flex-wrap gap-2">
                    {COLORES.map(c => {
                      const selected = form.color === c.value
                      return (
                        <button key={c.value} type="button" onClick={() => setForm({ ...form, color: c.value })} title={c.label}
                          className={`w-7 h-7 rounded-full transition-all ${c.dot} ${
                            selected ? 'ring-2 ring-offset-2 ring-gray-400 scale-110' : 'opacity-70 hover:opacity-100'
                          }`} />
                      )
                    })}
                  </div>
                  {/* Preview */}
                  <div className="flex items-center gap-2 pt-1 border-t border-[var(--line)]">
                    <span className="text-xs text-[var(--ink-4)]">Vista previa:</span>
                    {(() => {
                      const Icon = FiIcons[form.icono] || FiCalendar
                      return (
                        <span className={`inline-flex items-center px-3 py-1.5 rounded-lg text-sm font-medium ${form.color}`}>
                          <Icon className="h-4 w-4 mr-1.5" /> {form.nombre || 'Nombre'}
                        </span>
                      )
                    })()}
                  </div>
                </div>
              </div>

              {/* Opciones */}
              <div className="space-y-2">
                <label className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-purple-50 transition-colors">
                  <input type="checkbox" checked={form.solo_admin} onChange={e => setForm({...form, solo_admin: e.target.checked})}
                    className="w-4 h-4 text-purple-600 rounded" />
                  <div>
                    <span className="text-sm font-medium text-[var(--ink)]">Solo administrador</span>
                    <p className="text-xs text-[var(--ink-3)]">Solo el admin puede registrar este tipo</p>
                  </div>
                </label>
                <label className="flex items-center gap-3 p-3 border rounded-lg cursor-pointer hover:bg-orange-50 transition-colors">
                  <input type="checkbox" checked={form.requiere_documento} onChange={e => setForm({...form, requiere_documento: e.target.checked})}
                    className="w-4 h-4 text-orange-600 rounded" />
                  <div>
                    <span className="text-sm font-medium text-[var(--ink)]">Requiere justificante</span>
                    <p className="text-xs text-[var(--ink-3)]">Se indicará visualmente si falta el documento, pero no bloqueará la solicitud</p>
                  </div>
                </label>
              </div>

              <div className="flex gap-3 pt-2">
                <button type="button" onClick={cerrarModal} className="btn btn-secondary flex-1">Cancelar</button>
                <button type="submit" className="btn btn-primary flex-1">
                  <FiCheck className="mr-2" /> {modal.tipo ? 'Actualizar' : 'Crear'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  )
}
